import React, { Component } from "react";
import { track } from "@amplitude/analytics-browser";
import { AMPLITUDE_EVENTS } from "../config/amplitude";

class Thankyou extends Component {
  componentDidMount() {
    // Track survey step view
    track(AMPLITUDE_EVENTS.SURVEY_VIEW_STEP, {
      page_type: "Thankyou",
      step: this.props.values?.step,
      requestId: this.props.values?.requestId,
      medium: this.props.values?.medium,
    });
  }

  render() {
    return (
      <>
        <fieldset className="field16 current" id="field16">
          <h3>
            If you have any further questions regarding the survey <br></br>
            please email us at{" "}
            <span>
              <a href="mailto:wa.assistance@wiseradvisor.com">
                wa.assistance@wiseradvisor.com.
              </a>
            </span>
          </h3>
        </fieldset>
      </>
    );
  }
}

export default Thankyou;
